import { render } from "./RacunHis.vue?vue&type=template&id=fc140332&scoped=true"
import script from "./RacunHis.vue?vue&type=script&lang=js"
export * from "./RacunHis.vue?vue&type=script&lang=js"

import "./RacunHis.vue?vue&type=style&index=0&id=fc140332&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc140332"]])

export default __exports__